import { connect } from 'react-redux';
import H1Tag from '../components/H1Tag';

export default connect(
  state => {
    const { betaFeatures } = state.user;

    return ({
      h1TagsEnabled: betaFeatures.includes('CATALOGUE_H1_TAGS'),
    });
  },
)(H1Tag);
